import axios from 'axios';
import ServerProperties from '../config/server.js'

export function ModelReadAsMaster(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
    .then(function (response) {
        params.onsuccess(params, response);
    })
    .catch(error => {            
        params.onfailed(params, error.response)
    });
}

export function ModelReadMyAsset(params) {
    let myAssetUrl = 1;

    if(params.self.props.isAdmin) {
      switch(params.summaryTab){
          case 1 :
              myAssetUrl = 'Asset/All/';
              break;
          case 2 :
              myAssetUrl = 'Asset/All/DueInMonthService/';
              break;
          case 3 : 
              myAssetUrl = 'Asset/All/DueInWeekService/';
              break;
          case 4 :
              myAssetUrl = 'Asset/All/OverDueService/';
              break;
          default :
              myAssetUrl = 'Asset/All/';
              break;
      }
    } else {
      switch(params.summaryTab){
          case 1 :
              myAssetUrl = 'Asset/MyAssets/';
              break;
          case 2 :
              myAssetUrl = 'Asset/DueInMonthService/';
              break;
          case 3 : 
              myAssetUrl = 'Asset/DueInWeekService/';
              break;
          case 4 :
              myAssetUrl = 'Asset/OverDueService/';
              break;
          default :
              myAssetUrl = 'Asset/MyAssets/';
              break;
      }
    }
    
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API+myAssetUrl + '?page=' + params.page +'&'+ params.filter +'&'+ params.order
    )
    .then((response) => params.onsuccess(params, response))
    .catch((error) => params.onfailed(params, error));
}

export function ModelReadAllAsset(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
        ServerProperties.ATM_CLOUD.API + 'Asset/All/?search=' + params.data.Alias
    )
    .then(function (response) {
        params.onsuccess(params, response);
    })
    .catch(function (error) {
        params.onfailed(params, error.response)
    });
}

export function ModelReadMyAssetSummary(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
        ServerProperties.ATM_CLOUD.API + params.data.url
    )
    .then(function (response) {
        params.onsuccess(params, response);
    })
    .catch(function (error) {
        params.onfailed(params, error.response)
    });
}

export function ModelReadBookedAsset(params) {
	axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
	
  let urlRequest = ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Me/?' + params.data.order + '&' + params.data.filter + '&page=' + params.data.page
	
  if (params.action==='getDetails'){
		urlRequest = ServerProperties.ATM_CLOUD.API+'Asset/Info/?search='+params.alias
	} else if(params.action==='tag'){
    urlRequest = ServerProperties.ATM_CLOUD.API+'Asset/Info/?tag='+params.alias
  }

	axios.get(
		urlRequest
	)
	.then(function (response) {
		params.onsuccess(params, response);
	})
	.catch(function (error) {
    params.onfailed(params, error)
  });
}

export function ModelReadIncomingMessage(params) {
    let type     = params.self.nextParams.type;
    let status   = params.self.nextParams.status;
    let search   = params.self.nextParams.search;
    let response = 'all';

    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      // params.data.url === undefined ?
      ServerProperties.ATM_CLOUD.API+'Message/Confirmation/?type=' + type +'&search='+ search +'&status=' + status + '&response=' + response + (params.data.url ? '&last=' + params.data.url : '')
    )
    .then(function (response) {
        params.onsuccess(params, response);
    })
    .catch(function (error) {

    });
}

export function ModelReadMasterReservation(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + 'Booking/Reservation/' + params.data.query + '/')
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
        params.onfailed(error.response)
    });
}

export function ModelReadReservationCheck(params) {  
    axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
        axios.get(
            ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Check/' + params.data.Alias + '/',
            {}
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            // console.log(error.response)
            params.onfailed(error.response)
        });
  }

export function ModelReadQRReassign(params) {  
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.get(
    ServerProperties.ATM_CLOUD.API+'Message/Confirmation/QR/' + params.data.Alias + '/'
  )
  .then(function (response) {
    params.onsuccess(params, response)
  })
  .catch(error => {
    console.log(error)
    params.onfailed(params, error.response)
  });
}

// Register
export function ModelRegisterReasign(params) {  
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.post(
            ServerProperties.ATM_CLOUD.API+'Message/Confirmation/Register/',
            {
                Asset   : params.data.Asset,
                Message : params.data.Message,
                ToUser  : params.data.ToUser,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            // console.log(error.response)
            params.onfailed(error.response)
        });
}

export function BulkModelRegisterReasign(params) {  
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.post(
            ServerProperties.ATM_CLOUD.API+'Message/Confirmation/Register/',
            {
                Asset   : params.data.Asset,
                Message : params.data.Message,
                ToUser  : params.data.ToUser,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            // console.log(error.response)
            params.onfailed(error.response)
        });
}

export function ModelConfirmationAnswer(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.put(
            ServerProperties.ATM_CLOUD.API+'Message/Confirmation/Answer/' + params.data.ConfirmationAlias +'/',
            {
                Answer  :params.data.Answer,
                DueDate :params.data.DueDate,
                Message :params.data.Message,
                
                StartDate : params.data.StartDate,
                MyReservation : params.data.MyReservation,

                Site    : params.data.Site,
                Location: params.data.Location,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            console.log(error)
            params.onfailed(params, error.response)
        });
}

export function ModelRequestMaintenance(params) {
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.post(
    ServerProperties.ATM_CLOUD.API + 'Maintenance/Request/Register/',
    params.data.field
  )
  .then(function (response) {
    params.onsuccess(params, response)
  })
  .catch(error => {
    // console.log(error.response)
    params.onfailed(error.response)
  });
}

export function ModelRegisterQRReassign(params) {  
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.post(
    ServerProperties.ATM_CLOUD.API+'Message/Confirmation/QR/',
    {
        Asset   : params.data.Asset,
    }
  )
  .then(function (response) {
    params.onsuccess(params, response)
  })
  .catch(error => {
    console.log(error)
    params.onfailed(params, error.response)
  });
}

export function ModelQRConfirmationAnswer(params) { 
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.put(
    ServerProperties.ATM_CLOUD.API+'Message/Confirmation/QR/' + params.data.Alias + '/',
    {
      DueDate :params.data.DueDate,
      Message :params.data.Message,
      StartDate : params.data.StartDate,
      MyReservation : params.data.MyReservation,
      Site    : params.data.Site,
      Location: params.data.Location,
    }
  )
  .then(function (response) {
    params.onsuccess(params, response)
  })
  .catch(error => {
    console.log(error)
    params.onfailed(params, error.response)
  });
}

// UPDATE
export function ModelCancelReasign(params) {
    // console.log('model ModelCancelReasign');
    // console.log(params);
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
        ServerProperties.ATM_CLOUD.API+'Message/Confirmation/Cancel/'+params.data.Alias+'/'
    )
    .then(function (response) {
        params.onsuccess(params, response)
    })
    .catch(function (error) {
        params.onfailed(params, error.response)
        console.log(error) 
      });
}

export function ModelCancelBooking(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
        ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Cancel/'+params.self.state.SelectedItem.Alias+'/'
    )
    .then(function (response) {
        params.onsuccess(params, response)
    })
    .catch(error => {
        // console.log(error.response)
        params.onfailed(params, error.response)
    });
}

export function ModelUpdateReschedule(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Update/' + params.data.Alias + '/', 
        {
            StartDate   : params.data.StartDate,
            FinishDate  : params.data.FinishDate,
            Site        : params.data.Site,
            Location    : params.data.Location,
            Description : params.data.Description,
        }
    )
    .then(function (response) {
        params.onsuccess(params, response)
    })
    .catch(function (error) {
        if (error.response) {// The request was made and the server responded with a status code
            params.onfailed(params, error.response.data.detail) 
        } else if (error.request) {// The request was made but no response was received
            // console.log(error.request);
            params.onfailed(params, error.request) 
        } else {// Error System 
            // console.log('Error', error.message);
            params.onfailed(params, "Something went wrong")
        }
      });
}

export function ModelMoveAsset(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch(
        ServerProperties.ATM_CLOUD.API+'Asset/Move/' + params.data.AssetAlias + '/',
        {
            Site     : params.data.Site,
            Location : params.data.Location,
            DueDate  : params.data.DueDate
        }
    )
    .then(function (response) {
        params.onUpdateSuccess(params, response)
    })
    .catch(error => {
        console.log(error)
        params.onUpdateFailed(params, error.response)
    });
}

export function ModelReadSummary(params) {
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.get(
    ServerProperties.ATM_CLOUD.API+'Message/Confirmation/Summary/'
  )
  .then(function (response) {
      params.onsuccess(params, response)
  })
  .catch(error => {
    console.log(error.message);
    params.onfailed(error)
  });
}

export function ModelExtendDueDate(params) {
  axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
  axios.patch(
    ServerProperties.ATM_CLOUD.API+'Asset/Extend/' + params.data.id + '/', {
      DueDate: params.data.dueDate_UTC
    }
  )
  .then(function (response) {
      params.onsuccess(params, response)
  })
  .catch(error => {
      params.onfailed(error)
  });
}


// WEBPACK FOOTER //
// ./src/App/home/model.js